import React from "react";
import {SettingState} from "../interfaces/SettingState";
import MarketContext from "../../Main/interface/MarketContext";
import {NavigateFunction} from "react-router-dom";
import PayManager from "../../Pay/controller/PayManager";
import Toast from "../../../utility/toast";
import {withLang} from "../../../routes/LangLayout";

export default class SettingController {
    protected state: SettingState;
    protected setState: React.Dispatch<React.SetStateAction<SettingState>>;

    constructor(state: SettingState, setState: React.Dispatch<React.SetStateAction<SettingState>>) {
        this.state = state;
        this.setState = setState;
    }

    async getSetting() {
        this.updateState({loading: false});
    }

    changeActiveTab(active: any) {
        this.updateState({activeTab: active});
    }

    static backToHome(context: MarketContext, navigate: NavigateFunction, shopId: string) {
        context.setState((prevState) => ({...prevState, isAccess: false}))
        return navigate(withLang(`/${shopId}`), {replace: true});
    }

    static async posTest(setLoading: React.Dispatch<React.SetStateAction<boolean>>, navigator: NavigateFunction, shopId: string) {
        setLoading(true)
        const payment = await new PayManager({amount: 1000 * 10}, navigator, shopId).payTest();
        setLoading(false)

        if (payment.status) {
            return Toast.success(payment.data as string)
        }
        return Toast.error(payment.data as string)
    }

    private updateState(state: object) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}
